import { render } from "./OrderCreateModal.vue?vue&type=template&id=4d723682&scoped=true"
import script from "./OrderCreateModal.vue?vue&type=script&lang=js"
export * from "./OrderCreateModal.vue?vue&type=script&lang=js"

import "./OrderCreateModal.vue?vue&type=style&index=0&id=4d723682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d723682"]])

export default __exports__